<div class="se-fab-slider">
    <div *ngIf="buttonsVisible" class="se-fab-slider-buttons">
        <button (click)="onDecrease()" [disabled]="canDecrease()" mat-button>
            <mat-icon>{{ decreaseIcon }}</mat-icon>
        </button>
        <button (click)="onIncrease()" [disabled]="canIncrease()" mat-button>
            <mat-icon>{{ increaseIcon }}</mat-icon>
        </button>
    </div>
    <mat-slider
        #ngSlider
        [discrete]="showLabel"
        [displayWith]="formatLabel"
        [max]="max"
        [min]="min"
        [step]="step"
        class="se-mat-slider"
    >
        <input #slider (ngModelChange)="onInputChange($event)" [(ngModel)]="value" matSliderThumb />
    </mat-slider>
</div>
